<template>
    <div id="EditCase">
        <HeaderBackend />
        <br />
        <div class="portfolio-main-view">
            <label class="portfolio-label-center">列表用list圖</label>
            <img class="portfolio-img-view" v-if="PortfolioInfo != null && PortfolioInfo.ListPhotoUrl != ''" :src="PortfolioInfo.ListPhotoUrl + '?' + Math.random()" />
            <div class="portfolio-upload-center">
                <label>更新圖片</label>
                <input class="portfolio-upload-button" type="file" accept=".jpg, .png" @change="ListPhotoUpload">
            </div>
        </div>
        
        <div class="portfolio-main-view">
            <label class="portfolio-label-center">主要大圖</label>
            <img class="portfolio-img-view" v-if="PortfolioInfo != null && PortfolioInfo.PhotoUrl != ''" :src="PortfolioInfo.PhotoUrl + '?' + Math.random()" />
            <div class="portfolio-upload-center">
                <label>更新圖片</label>
                <input class="portfolio-upload-button" type="file" accept=".jpg, .png" @change="PhotoUpload">
            </div>
        </div>

        <br />
        
        <div class="portfolio-center" v-if="PortfolioInfo != null">
            <!-- <div class="portfolio-type">{{ `類別 | ${PortfolioInfo.Type}` }}</div> -->
            <label class="portfolio-label-center" style="color: red;">下面輸入要按enter跳OK才算存檔</label>
            <div style="height:30px"></div>
            <div class="portfolio-type">
                <span class="type-title">類別</span>
                <span class="space-line">|</span>
                <input class="type-content" type="text" maxlength="20" size="20" v-model="PortfolioInfo.Type" @keyup.enter="updateTypeText"/>
            </div>
            
            <div class="clear-both"></div>

            <div class="portfolio-skill">
                <span class="type-title">技術</span>
                <span class="space-line">|</span>
                <input class="type-content" type="text" maxlength="20" size="20" v-model="PortfolioInfo.Skill" @keyup.enter="updateSkillText"/>
            </div>
            <div class="clear-both"></div>

            <div class="portfolio-skill">
                <span class="type-title">標題</span>
                <span class="space-line">|</span>
                <input class="type-content" type="text" maxlength="20" size="20" v-model="PortfolioInfo.Title" @keyup.enter="updateTitleText"/>
            </div>

            <div class="clear-both"></div>

            <div class="portfolio-skill">
                <span class="type-title">單位</span>
                <span class="space-line">|</span>
                <input class="type-content" type="text" maxlength="20" size="20" v-model="PortfolioInfo.Client" @keyup.enter="updateClientText"/>
            </div>

            <div class="clear-both"></div>

            <div style="display: block; height:50px">
                <label class="portfolio-label-center" style="color: red;">下面輸入離開輸入框跳OK才算存檔</label>
            </div>
            

            <div class="portfolio-skill">
                <span class="type-title">Intro</span>
                <span class="space-line">|</span>
                <textarea class="textarea-content" v-model="PortfolioInfo.Intro" @blur="updateIntroText" rows="10"></textarea>
            </div>

            <div style="height:300px"></div>

            <div class="portfolio-skill">
                <span class="type-title">內容</span>
                <span class="space-line">|</span>
                <textarea class="textarea-content" v-model="PortfolioInfo.Content" @blur="updateContentText" rows="10"></textarea>
            </div>

            <div class="clear-both"></div>

            <label class="portfolio-label-center">專案圖片</label>
            <br />
            
            <div v-for="p in PortfolioInfo.PhotoList" :key="p.Serial">
                <label class="portfolio-label-center">圖片{{p.Index}}</label>
                <img class="portfolio-img" :src="p.Url + '?' + Math.random()" />
                <div class="portfolio-upload-center">
                    <label>更新圖片</label>
                    <input class="portfolio-upload-button" :id="p.Serial" type="file" accept=".jpg, .png" @change="ResultPhotoUpload">
                    <input type="button"  :id="p.Serial" value="刪除" @click="OnDeleteResultPhoto"/>
                </div>
                
            </div>
            
            <div style="height:50px"></div>

            <input type="button" class="portfolio-button" value="新增圖片" @click="OnAddResultPhoto"/>

            <div style="height:50px"></div>
            
            <div class="portfolio-skill" style="height:650px" v-for="p in PortfolioInfo.YoutubeList" :key="p.Serial">
                <span class="type-title">影片{{p.Index}}</span>
                <input class="type-content" type="text" maxlength="500" size="20" :id="p.Serial" v-model="p.Url" @keyup.enter="ResultVideoUpload"/>

                <iframe
                class="portfolio-iframe"
                title="YouTube video player"
                frameborder="0"
                allow="autoplay; encrypted-media"
                 :src="p.Url"
            
                allowfullscreen
                ></iframe>
                <input type="button"  :id="p.Serial" value="刪除" @click="OnDeleteResultVideo"/>
            </div>

            <input type="button" class="portfolio-button" value="新增影片連結" @click="OnAddResultVideo"/>
        </div>
        <Loading
            :active.sync="loadingInfo.isLoading"
            :can-cancel="false"
            :is-full-page="true"
            :color="loadingInfo.color"
            :opacity="loadingInfo.opacity"
            :background-color="loadingInfo.bgColor"
        ></Loading>
    </div>
  </template>
  
  <script>
  import HeaderBackend from '@/components/header/HeaderBackend.vue';
  import { apiGetPortfolioEdit , apiPostListPhoto , apiPostPhoto, apiPostUpdateTextData , apiPostAddResultPhoto, apiPostDeleteResultPhoto, apiPostUploadResultPhoto, apiPostAddResultVideo, apiPostDeleteResultVideo, apiPostUploadResultVideo } from '@/request.js';
  import Loading from 'vue-loading-overlay';
  import 'vue-loading-overlay/dist/vue-loading.css';
  // import AOS from 'aos';
  // import 'aos/dist/aos.css';
  export default {
    mounted() {
      //AOS.init();
      const ltoken = sessionStorage.getItem('ltoken');
        if (ltoken) {
        // 已登入，可以進行相關操作
        } else {
        // 未登入，導向登入頁面
            this.$router.push({ path: '/Backend/Main' });
            this.ScrollTO('Header');
            return;
        }

      let Serial = this.GetParameterByName('s');
      let Type = this.GetParameterByName('t') == null ? '' : this.GetParameterByName('t');
      if (Serial != null) {
        this.GetPortfolioInfo(Serial, Type);
      } else {
        this.PortfolioListPage();
      }
    },
    data() {
      return {
        SEOTitle: 'News 精選案例',
        SEODesc: 'SURREAL 超現實科技 - 精選案例',
        // AOS: {
        //   Offset: '270',
        //   Dur: '1200',
        // },
        PortfolioInfo: null,
        PhotoListFile: "",
        loadingInfo: {
          isLoading: false,
          color: '#fff',
          opacity: 0.9,
          bgColor: '#131217',
        },
      };
    },
    metaInfo() {
      return {
        title: this.SEOTitle,
        meta: [
          {
            name: 'description',
            content: this.SEODesc,
          },
        ],
      };
    },
    computed: {},
    methods: {
        GetPortfolioInfo(Serial, Type) {
            this.loadingInfo.isLoading = true;
            apiGetPortfolioEdit(Type, Serial).then((res) => {
            this.loadingInfo.isLoading = false;
            if (res.data.Status == 'ok') {
                this.PortfolioInfo = res.data.PortfolioInfo;
                this.SEOTitle = this.PortfolioInfo.Title;
                this.SEODesc = this.PortfolioInfo.Content.slice(0, 160);
                this.AutoResizeTextArea();

                for (let i = 0; i < this.PortfolioInfo.PhotoList.length; i++) {
                    this.PortfolioInfo.PhotoList[i].Index = i + 1;
                }
            } else {
                this.$toasted.show(`Error:${res.data.Error}, Code:${res.data.Code}`, {
                icon: 'warning',
                position: 'bottom-center',
                duration: 3500,
                });
                this.PortfolioListPage();
            }
            });
            // this.PortfolioInfo = {
            //   Serial: '1',
            //   PhotoUrl:
            //     'https://static.wixstatic.com/media/0e0992_30869f31a46b48aaa11fb1d2fbd93f92~mv2.jpg/v1/fill/w_514,h_372,al_c,q_80,usm_0.66_1.00_0.01,enc_auto/Image-empty-state.jpg',
            //   Type: '互動科技',
            //   Skill: 'AR/VR/MR/GRAPHIC DESIGN/INTERACTION DESIGN/AR/VR/MR/GRAPHIC DESIGN/',
            //   Title: 'VR虛擬賞車VR虛擬賞車VR虛擬賞車VR虛擬賞車VR虛擬賞車',
            //   Content:
            //     'VR虛擬實境一直是眾所期待的重大技術，使用者只要戴上VR頭盔即可進入一個充滿無限想像的虛擬空間。「虛擬賞車」概念由此而生，我們利用這個特點去解決以往車廠因展間空間不足而無法展示所有車款的問題，賞車民眾可於VR頭盔內看到指定車款樣式，搭載車款特點介紹，隨心進行車色、視角變換、360度環視等體驗，此專案於2019年導入和泰汽車全台營業所，不僅能解決展間空間限制的問題，亦可透過新興科技技術提升民眾賞車時的樂趣。此外，我們也另外收集民眾的體驗數據，透過後台數據分析，提供業主最有價值的數據瀏覽，藉此了解民眾對於各車款的喜好。',
            //   PhotoList: [
            //     {
            //       Serial: '7',
            //       Url: 'https://static.wixstatic.com/media/0e0992_30869f31a46b48aaa11fb1d2fbd93f92~mv2.jpg/v1/fill/w_514,h_372,al_c,q_80,usm_0.66_1.00_0.01,enc_auto/Image-empty-state.jpg',
            //     },
            //     {
            //       Serial: '8',
            //       Url: 'https://static.wixstatic.com/media/0e0992_30869f31a46b48aaa11fb1d2fbd93f92~mv2.jpg/v1/fill/w_514,h_372,al_c,q_80,usm_0.66_1.00_0.01,enc_auto/Image-empty-state.jpg',
            //     },
            //   ],
            //   YoutubeList: [
            //     {
            //       Serial: '15',
            //       Url: 'https://www.youtube.com/embed/IvuEqW051ak',
            //     },
            //     {
            //       Serial: '87',
            //       Url: 'https://www.youtube.com/embed/IvuEqW051ak',
            //     },
            //   ],
            //   Last: '',
            //   Next: 'http://localhost:8080/Portfolio?s=30&t=1',
            // };
        },
  
        PortfolioPage(Url) {
            location.replace(Url);
        },
        PortfolioListPage() {
            this.$router.push({ path: '/Backend/AddCase' });
            this.ScrollTO('Header');
        },
        ListPhotoUpload(event) {
            const file = event.target.files[0];
            if (!file.type.match('image/jpeg') && !file.type.match('image/png')) {
                alert('請上傳 JPEG or Png 格式的圖片');
                return;
            }

            const reader = new FileReader();
            reader.onload = () => {
                const fileContent = reader.result;

                let data = {
                    Serial : this.PortfolioInfo.Serial,
                    FileData: fileContent,
                };

                apiPostListPhoto(data).then((res) => {
                    let resp = res.data;
                    let errMsg = 'GGG'
                    if (resp.Status == 'ok') {
                        errMsg = resp.Status;

                        this.PortfolioInfo.ListPhotoUrl = resp.FileUrl

                        this.$forceUpdate();
                    }

                    this.$toasted.show(errMsg, {
                    icon: 'warning',
                    position: 'bottom-center',
                    duration: 3500,
                    });
                });
            };

            reader.readAsDataURL(file);

        },
        PhotoUpload(event) {
            const file = event.target.files[0];
            if (!file.type.match('image/jpeg') && !file.type.match('image/png')) {
                alert('請上傳 JPEG or Png 格式的圖片');
                return;
            }

            const reader = new FileReader();
            reader.onload = () => {
                const fileContent = reader.result;

                let data = {
                    Serial : this.PortfolioInfo.Serial,
                    FileData: fileContent,
                };

                apiPostPhoto(data).then((res) => {
                    let resp = res.data;
                    let errMsg = 'GGG'
                    if (resp.Status == 'ok') {
                        errMsg = resp.Status;

                        this.PortfolioInfo.PhotoUrl = resp.FileUrl

                        this.$forceUpdate();
                    }

                    this.$toasted.show(errMsg, {
                    icon: 'warning',
                    position: 'bottom-center',
                    duration: 3500,
                    });
                });
            };

            reader.readAsDataURL(file);
        },
        updateTypeText() {
            let data = {
                    Serial : this.PortfolioInfo.Serial,
                    TextData: this.PortfolioInfo.Type,
                    UpdateType: "Type",
                };

            this.CallApiUpateTextData(data)
        },
        updateSkillText() {
            let data = {
                    Serial : this.PortfolioInfo.Serial,
                    TextData: this.PortfolioInfo.Skill,
                    UpdateType: "Skill",
                };

            this.CallApiUpateTextData(data)
        },
        updateTitleText() {
            let data = {
                    Serial : this.PortfolioInfo.Serial,
                    TextData: this.PortfolioInfo.Title,
                    UpdateType: "Title",
                };

            this.CallApiUpateTextData(data)
        },
        updateClientText() {
            let data = {
                    Serial : this.PortfolioInfo.Serial,
                    TextData: this.PortfolioInfo.Client,
                    UpdateType: "Client",
                };

            this.CallApiUpateTextData(data)
        },
        updateIntroText(event) {
            console.log("輸入後內容：", event.target.value);
            let data = {
                    Serial : this.PortfolioInfo.Serial,
                    TextData: this.PortfolioInfo.Intro,
                    UpdateType: "Intro",
                };

            this.CallApiUpateTextData(data)
        },
        updateContentText(event) {
            console.log("輸入後內容：", event.target.value);
            let data = {
                    Serial : this.PortfolioInfo.Serial,
                    TextData: this.PortfolioInfo.Content,
                    UpdateType: "Content",
                };

            this.CallApiUpateTextData(data)
        },
        CallApiUpateTextData(data) {
            apiPostUpdateTextData(data).then((res) => {
                let resp = res.data;
                let errMsg = 'GGG'
                if (resp.Status == 'ok') {
                    errMsg = resp.Status;
                }

                this.$toasted.show(errMsg, {
                icon: 'warning',
                position: 'bottom-center',
                duration: 3500,
                });
            });
        },
        OnAddResultPhoto()
        {
            let data = {
                    Serial : this.PortfolioInfo.Serial,
                };

            apiPostAddResultPhoto(data).then((res) => {
                let resp = res.data;
                let errMsg = 'GGG'
                if (resp.Status == 'ok') {
                    errMsg = resp.Status;

                    this.PortfolioInfo.PhotoList = resp.PhotoList;
                    for (let i = 0; i < this.PortfolioInfo.PhotoList.length; i++) {
                        this.PortfolioInfo.PhotoList[i].Index = i + 1;
                    }
                }

                this.$toasted.show(errMsg, {
                icon: 'warning',
                position: 'bottom-center',
                duration: 3500,
                });
            });
        },
        OnDeleteResultPhoto()
        {
            const fileUpload = event.target;
            const buttonId = fileUpload.id;

            let data = {
                Serial : buttonId,
            };

            apiPostDeleteResultPhoto(data).then((res) => {
                let resp = res.data;
                let errMsg = 'GGG'
                if (resp.Status == 'ok') {
                    errMsg = resp.Status;

                    this.PortfolioInfo.PhotoList = resp.PhotoList;
                    for (let i = 0; i < this.PortfolioInfo.PhotoList.length; i++) {
                        this.PortfolioInfo.PhotoList[i].Index = i + 1;
                    }
                }

                this.$toasted.show(errMsg, {
                    icon: 'warning',
                    position: 'bottom-center',
                    duration: 3500,
                });
            });
        },
        ResultPhotoUpload(event) {
            const fileUpload = event.target;
            const buttonId = fileUpload.id;

            const file = event.target.files[0];
            if (!file.type.match('image/jpeg') && !file.type.match('image/png')) {
                alert('請上傳 JPEG or Png 格式的圖片');
                return;
            }

            const reader = new FileReader();
            reader.onload = () => {
                const fileContent = reader.result;

                let data = {
                    Serial : buttonId,
                    FileData: fileContent,
                };

                apiPostUploadResultPhoto(data).then((res) => {
                    let resp = res.data;
                    let errMsg = 'GGG'
                    if (resp.Status == 'ok') {
                        errMsg = resp.Status;

                        for (let i = 0; i < this.PortfolioInfo.PhotoList.length; i++) {
                            if(this.PortfolioInfo.PhotoList[i].Serial == buttonId)
                            {
                                this.PortfolioInfo.PhotoList[i].Url = resp.FileUrl
                            }
                        }

                        event.target.value = '';

                        this.$forceUpdate();
                    }

                    this.$toasted.show(errMsg, {
                    icon: 'warning',
                    position: 'bottom-center',
                    duration: 3500,
                    });
                });
            };

            reader.readAsDataURL(file);
        },
        OnAddResultVideo()
        {
            let data = {
                    Serial : this.PortfolioInfo.Serial,
                };

            apiPostAddResultVideo(data).then((res) => {
                let resp = res.data;
                let errMsg = 'GGG'
                if (resp.Status == 'ok') {
                    errMsg = resp.Status;

                    this.PortfolioInfo.YoutubeList = resp.YoutubeList;
                    for (let i = 0; i < this.PortfolioInfo.YoutubeList.length; i++) {
                        this.PortfolioInfo.YoutubeList[i].Index = i + 1;
                    }
                }

                this.$toasted.show(errMsg, {
                icon: 'warning',
                position: 'bottom-center',
                duration: 3500,
                });
            });
        },
        OnDeleteResultVideo()
        {
            const fileUpload = event.target;
            const buttonId = fileUpload.id;

            let data = {
                Serial : buttonId,
            };

            apiPostDeleteResultVideo(data).then((res) => {
                let resp = res.data;
                let errMsg = 'GGG'
                if (resp.Status == 'ok') {
                    errMsg = resp.Status;

                    this.PortfolioInfo.YoutubeList = resp.YoutubeList;
                    for (let i = 0; i < this.PortfolioInfo.YoutubeList.length; i++) {
                        this.PortfolioInfo.YoutubeList[i].Index = i + 1;
                    }
                }

                this.$toasted.show(errMsg, {
                    icon: 'warning',
                    position: 'bottom-center',
                    duration: 3500,
                });
            });
        },
        ResultVideoUpload(event) {
            const videoUpload = event.target;
            const textId = videoUpload.id;

            let data = {
                Serial : textId,
                Url : "",
            };

            for (let i = 0; i < this.PortfolioInfo.YoutubeList.length; i++) {
                if(this.PortfolioInfo.YoutubeList[i].Serial == textId)
                {
                    data.Url = this.PortfolioInfo.YoutubeList[i].Url
                }
            }

            apiPostUploadResultVideo(data).then((res) => {
                let resp = res.data;
                let errMsg = 'GGG'
                if (resp.Status == 'ok') {
                    errMsg = resp.Status;

                    for (let i = 0; i < this.PortfolioInfo.YoutubeList.length; i++) {
                        if(this.PortfolioInfo.YoutubeList[i].Serial == textId)
                        {
                            this.PortfolioInfo.YoutubeList[i].Url = resp.Url
                        }
                    }

                    event.target.value = '';

                    this.$forceUpdate();
                }

                this.$toasted.show(errMsg, {
                icon: 'warning',
                position: 'bottom-center',
                duration: 3500,
                });
            });
        },
    },
    components: { HeaderBackend , Loading },
  };
  </script>
  